import { Component } from 'vue-property-decorator' ;
import { ContentLoader } from 'vue-content-loader' ;
import LoaderPalette from '../../../../components/loader-palette';

@Component({
    components: {
        ContentLoader
    }
})
class AgendaSidebarLoader extends LoaderPalette {

    dtTextBox: { 
        width: number, 
        height: number,
        radius: number,
        top: number,
        left: number
    }

    constructor(){
        super()

        this.dtTextBox= {
            width: 250,
            height: 30,
            radius: 10,
            top: 10,
            left: 0
        }
    }
}

export default AgendaSidebarLoader


// WEBPACK FOOTER //
// ./src/containers/agenda/loaders/agenda-sidebar-loader/index.ts